import { render, staticRenderFns } from "./ViewOrderDetailsModal.vue?vue&type=template&id=69b4d47a"
import script from "./ViewOrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./ViewOrderDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports